import GenericMenuItem from './GenericMenuItem'
import { useGetIdentity, useTranslate } from 'react-admin'
import { Landscape } from "@mui/icons-material"

const UserLogoMenu = () => {

  const translate = useTranslate()
  const { data: identity, isLoading } = useGetIdentity()
  if(isLoading || !identity) return null

  return (
    <GenericMenuItem 
      title={translate('resources.logo.name')}
      link={`/users/${identity.id}/logo`}
      icon={<Landscape />}
    />
  )
}

export default UserLogoMenu